import React, { useState } from "react";
import { Button, FormFieldSet, Modal } from "../../../../../components";

const ResendModal = ({
  resendModalOpen,
  setResendModalOpen,
  setViewModalOpen,
  actionsHandler,
}) => {
  const [comment, setComment] = useState("");
  return (
    <Modal
      isOpen={resendModalOpen}
      title={"Resend Document"}
      titleColor={"black"}
      size="sm"
      showCloseButton={false}
      width="max-w-2xl"
    >
      <div className="flex flex-col gap-2">
        <FormFieldSet
          type="textArea"
          noTitle
          rows={3}
          placeholder="Enter"
          value={comment}
          onChange={(val) => setComment(val)}
        />
        <div className="flex items-center justify-end gap-4 mt-15">
          <Button
            title={"Cancel"}
            variant="outlined"
            className="!py-1"
            onClick={() => {
              (setResendModalOpen(false),
                // setViewModalOpen(false),
                setComment(""));
            }}
          />
          <Button
            title={"Submit"}
            className="!py-1"
            onClick={() =>
              actionsHandler("resend", {
                comment: comment,
              })
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default ResendModal;
